<template id="chapters-subject-page">
  <div class="is-100-vw">
    <div class="container mt-4">
      <div class="columns">
        <div class="column is-6">
          <CursoDropdown 
            v-model="selectedCurso" 
            :mostrarErrores="mostrarErrores" 
            tooltip="Selecciona un curso" 
            @update:modelValue="onCursoChange"
          />
        </div>
        <div class="column is-6">
          <AsignaturaDropdown 
            v-model="selectedAsignatura" 
            :mostrarErrores="mostrarErrores" 
            tooltip="Selecciona una asignatura" 
            @update:modelValue="onAsignaturaChange"
          />
        </div>
      </div>
    </div>

    <br /><br />

    <div v-if="current_capitulo" class="container mt-4 is-bold ml-4 is-gapless has-text-success is-size-3 z-index-30 text-glow">
      {{ current_capitulo }}
    </div>

    <div v-if="subject" class="container ml-4 is-size-7 z-index-30">
      {{ subject.Cantidad_videos }} Videos || {{ orderedGroupedChapters.length }} unidades
    </div>

    <div v-for="(unit, index) in orderedGroupedChapters" :key="unit.unidad" class="column is-12" style="z-index:30;">
      <div class="unit-border" style="z-index:30; position: relative">
        <div class="container ml-2 z-index-30">
          <span class="is-bold has-text-info is-size-5">{{ getUnidadLabel(index, unit.unidad) }}</span>
          <p class="has-text-grey is-size-7 z-index-30">
            {{ unit.grupos.length }} capítulos || 
            {{ unit.grupos.reduce((acc, curr) => acc + curr.capitulos.reduce((total, cap) => total + getVideosCap(cap.IdCapitulo).length, 0), 0) }} videos
          </p>
          <button @click="updateUnitOrder(unit)" class="button is-small is-info mt-2">Actualizar Unidad</button>
        </div>
        <div v-for="grupo in unit.grupos" :key="grupo.grupo" style="z-index:30;">
          <p class="container is-6 ml-3 mt-4" style="z-index:30;">
            <span class="has-text-grey is-bold is-size-6" style="z-index:30;">Capítulo: {{ grupo.grupo }}</span>
            <input type="number" v-model="grupo.newOrden" placeholder="Nuevo orden" class="input is-small ml-2" />
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SobjectService from '@/services/SobjectService';
import CursoDropdown from '@/components/selectores/CursoDropdown.vue';
import AsignaturaDropdown from '@/components/selectores/AsignaturaDropdown.vue';

export default {
  name: 'chapters-subject-page',
  components: {
    CursoDropdown,
    AsignaturaDropdown,
  },
  data() {
    return {
      subject: null,
      orderedGroupedChapters: [],
      selectedCurso: [],
      selectedAsignatura: [],
      mostrarErrores: false,
    };
  },
  methods: {
    parsePrefix(str) {
      const match = str.match(/^(I|II|III|IV|V|VI|VII|VIII|IX|X|\d+)/);
      if (!match) return 0;
      const pre = match[0];
      if (/\d+/.test(pre)) return parseInt(pre);
      const romanToInt = { I: 1, II: 2, III: 3, IV: 4, V: 5, VI: 6, VII: 7, VIII: 8, IX: 9, X: 10 };
      return romanToInt[pre] || 0;
    },
    removePrefix(str) {
      return str.replace(/^(I|II|III|IV|V|VI|VII|VIII|IX|X|\d+)[.:]?\s*/, '').trim();
    },
    getUnidadLabel(index, unidad) {
      let nuevaUnidad = unidad.replace(/^(I|II|III|IV|V|VI|VII|VIII|IX|X)\./, '').trim();
      if (nuevaUnidad.toLowerCase().startsWith('unidad')) {
        return `${nuevaUnidad}`;
      }
      return `Unidad ${index + 1}: ${nuevaUnidad}`;
    },
    getVideosCap(idd) {
      return this.subject?.VideosCapitulo.filter(x => x.IdCapitulo === idd) || [];
    },
    getChapters(id_curso, id_asignatura) {
      this.$store.dispatch('form/submit', true);
      SobjectService.getDataSubjects(id_curso, id_asignatura)
        .then(response => {
          this.subject = response.data;
          const groupedByUnit = this.subject.Capitulos.reduce((units, chapter) => {
            const unitKey = chapter.UnidadGrupo;
            if (!units[unitKey]) units[unitKey] = {};
            const groupKey = chapter.GlosaGrupo;
            if (!units[unitKey][groupKey]) units[unitKey][groupKey] = [];
            units[unitKey][groupKey].push(chapter);
            return units;
          }, {});

          Object.keys(groupedByUnit).forEach(unitKey => {
            Object.keys(groupedByUnit[unitKey]).forEach(groupKey => {
              groupedByUnit[unitKey][groupKey].sort((a, b) => a.Orden - b.Orden);
            });
          });

          this.orderedGroupedChapters = Object.entries(groupedByUnit)
            .sort(([u1], [u2]) => this.parsePrefix(u1) - this.parsePrefix(u2))
            .map(([unidad, grupos]) => ({
              unidad,
              grupos: Object.entries(grupos)
                .sort(([g1], [g2]) => this.parsePrefix(g1) - this.parsePrefix(g2))
                .map(([grupo, capitulos]) => ({ grupo, capitulos, newOrden: '' }))
            }));
          this.$store.dispatch('form/submit', false);
        })
        .catch(error => {
          console.error('Error al obtener los capítulos:', error);
          this.$store.dispatch('form/submit', false);
        });
    },
    onCursoChange(newValue) {
      this.selectedCurso = newValue;
      if (this.selectedCurso.length && this.selectedAsignatura.length) {
        this.getChapters(this.selectedCurso[0], this.selectedAsignatura[0]);
      }
    },
    onAsignaturaChange(newValue) {
      this.selectedAsignatura = newValue;
      if (this.selectedCurso.length && this.selectedAsignatura.length) {
        this.getChapters(this.selectedCurso[0], this.selectedAsignatura[0]);
      }
    },
    async updateUnitOrder(unit) {
      // Validar que todos los newOrden estén completos y sean numéricos positivos
      const invalidGroups = unit.grupos.filter(
        grupo => !grupo.newOrden || isNaN(grupo.newOrden) || grupo.newOrden <= 0
      );
      if (invalidGroups.length > 0) {
        alert('Todos los campos de orden deben estar completos con números positivos.');
        return;
      }

      try {
        // Procesar cada grupo y sus capítulos secuencialmente
        for (const grupo of unit.grupos) {
          const newPrefix = `${grupo.newOrden}: `;
          const baseGrupo = this.removePrefix(grupo.grupo);
          const newGrupo = `${newPrefix}${baseGrupo}`;

          for (const cap of grupo.capitulos) {
            const baseGlosa = this.removePrefix(cap.Glosa);
            const newGlosa = `${newPrefix}${baseGlosa}`;
            const payload = {
              IdCapitulo: cap.IdCapitulo,
              Glosa: newGlosa,
              GlosaGrupo: newGrupo,
            };
            // Llamada secuencial al endpoint
            await SobjectService.updateChapter(payload);
            cap.Glosa = newGlosa;
            cap.GlosaGrupo = newGrupo;
          }
          grupo.grupo = newGrupo;
        }
        // Refrescar los datos después de todas las actualizaciones
        await this.getChapters(this.selectedCurso[0], this.selectedAsignatura[0]);
        alert('Unidad actualizada correctamente.');
      } catch (error) {
        console.error('Error actualizando orden de la unidad:', error);
        alert('Error al actualizar la unidad. Por favor, intenta de nuevo.');
      }
    },
  },
  created() {
    if (this.$route.params.curso_id && this.$route.params.asignatura_id) {
      this.selectedCurso = [this.$route.params.curso_id];
      this.selectedAsignatura = [this.$route.params.asignatura_id];
      this.getChapters(this.selectedCurso[0], this.selectedAsignatura[0]);
    }
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      token: 'auth/access-token',
      current_capitulo: 'toolbar/title'
    })
  }
};
</script>

<style scoped>
.is-background { z-index: 1; }
.columns-horizontal-scroll { 
  display: flex; 
  overflow-x: auto; 
  white-space: nowrap; 
  padding: 10px 0; 
}
.columns-horizontal-scroll .column { 
  display: inline-block; 
  margin-right: 15px; 
}
.column { flex: 0 0 auto; }
.text-glow { 
  text-shadow: 0 0 10px rgba(255, 255, 255, 0.9), 0 0 20px rgba(255, 255, 255, 0.8), 0 0 30px rgba(255, 255, 255, 0.7), 0 0 40px rgba(255, 255, 255, 0.6), 0 0 50px rgba(255, 255, 255, 0.5); 
}
.unit-border { 
  border: 0.1px solid #c0c0c0 !important; 
  border-radius: 8px !important; 
  padding: 16px; 
  margin-bottom: 12px !important; 
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2) !important; 
  z-index: 30 !important; 
}
</style>